import { object, string } from 'yup';

export const dadosPessoaisSchema = object({
  id: string(),
  nome: string(),
  rg: string().required('O documento de identificação é obrigátorio'),
  cpf: string(),
  dtNascimento: string()
    .matches(
      /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/,
      'Data inválida'
    )
    .required('A data de nascimento é obrigatória'),
  nacionalidade: string().required('A nacionalidade é obrigatória'),
  sexo: string(),
  estadoCivil: string().required('O estado civil é obrigatório'),
  pai: string().required('O nome do pai é obrigatório'),
  mae: string().required('O nome da mãe é obrigatório'),
});

export class DadosPessoaisModel {
  id = '';

  nome = '';

  rg = '';

  cpf = '';

  nascimento = '';

  dtNascimento = '';

  sexo = '';

  estadoCivil = '';

  pai = '';

  mae = '';
}
